/** @jsx jsx */
import { jsx } from "theme-ui"
import { graphql } from "gatsby"
import ShopContainer from "@shop/modules/ShopContainer"

const PageShop = ({ data, ...props }) => {
  return (
    <ShopContainer
      pageContent={{
        heading: "Shop Pride Merchandise",
        image: data.og.frontmatter.headerImg,
        pillHeading: "What are you looking for?",
        pageTitle: "Shop LGBTQIA+ Pride",
        headerText:
          "Flags, badges, stickers, lanyards – show your pride every day, and support LGBTQIA+ youth with your purchase.",
        pageDescription: data.og.frontmatter.ogdescription,
        threeUp: data.threeUp.frontmatter.threeUp,
        ctaLink: data.ctaLink.frontmatter.ctaLinkObject,
      }}
      data={data}
      pathname={props.location.pathname}
      location={props.location}
      headerBg="purple"
      headerColor="white"
    />
  )
}

export default PageShop

export const pageQuery = graphql`
  query {
    ctaLink: markdownRemark(fileAbsolutePath: { glob: "**/pages/shop/index.md" }) {
      frontmatter {
      ctaLinkObject {
          link
          label
        }
      }
    }

    threeUp: markdownRemark(fileAbsolutePath: { glob: "**/pages/shop/index.md" }) {
      frontmatter {
        threeUp {
          ...ThreeUp
        } 
      }
    }
    pride: shopifyCollection(handle: { eq: "pride" }) {
      ...ShopifyCollectionFragment
    }
    school: shopifyCollection(handle: { eq: "schools" }) {
      ...ShopifyCollectionFragment
    }
    workplace: shopifyCollection(handle: { eq: "workplace" }) {
      ...ShopifyCollectionFragment
    }
    og: markdownRemark(fileAbsolutePath: { glob: "**/pages/shop/index.md" }) {
      frontmatter {
        ogdescription
        headerImg
        accordion {
          ...Accordion
        }
        footerImg
      }
    }
  }
`
